module.exports = __webpack_public_path__ + "static/media/temp_chart1.c47d15bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/colonyGame/temp_chart1.png
// module id = 2279
// module chunks = 0